import React from 'react'
import {  } from 'react-router-dom';


import Navbar from './Navbar';
import style from './Wellness.module.css'
import Category from './Category';
const Wellness = () => {
    
  return (
    <>
<Navbar/>
  
      <div className={style.hero_section}>
        <h2 className={style.hero_title}>Unlock Flexibility, Calmness & Inner Strength</h2>
        <p className={style.hero_text}>
          Yoga blends breath, movement and mindfulness—helping you build strength, reduce stress, improve balance, and feel deeply connected to your body every day.
        </p>
      </div>
<Category/>
            
     
</>
  )
}

export default Wellness